import { render } from "./companies.vue?vue&type=template&id=5e09ad0a&scoped=true"
import script from "./companies.vue?vue&type=script&lang=js"
export * from "./companies.vue?vue&type=script&lang=js"

import "./companies.vue?vue&type=style&index=0&id=5e09ad0a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e09ad0a"]])

export default __exports__